import { APIGet, APIPost, APIPut, APIDelete, APIUrl, AdminType } from "api/protocols";
import { CancelToken } from "axios";
import { ITeeTimePromotion } from "redux/reducers/models/teetime";

interface IGetTeeTimePromotion {
  id?: number;
}

interface IPostTeeTimePromotion {
  title: string;
  promotion_type: "percent" | "amount";
  promotion_value: number;
  promotion_label?: string | null;
}

interface IPutTeeTimePromotion {
  id: number;
  title: string;
  promotion_type: "percent" | "amount";
  promotion_value: number;
  promotion_label?: string | null;
}

interface IDeleteTeeTimePromotion {
  id: number;
}

export async function GetTeeTimePromotions(
  params: IGetTeeTimePromotion | null,
  useGlobalLoader: boolean,
  token?: CancelToken,
) {
  return await APIGet<ITeeTimePromotion[]>(
    APIUrl(AdminType.FacilityAdmin, "/tee-sheet/promotion"),
    params,
    useGlobalLoader,
    token,
  );
}

export async function PostTeeTimePromotion(params: IPostTeeTimePromotion, useGlobalLoader: boolean) {
  return await APIPost<ITeeTimePromotion>(
    APIUrl(AdminType.FacilityAdmin, "/tee-sheet/promotion"),
    params,
    useGlobalLoader,
  );
}

export async function PutTeeTimePromotion(params: IPutTeeTimePromotion, useGlobalLoader: boolean) {
  return await APIPut<ITeeTimePromotion>(
    APIUrl(AdminType.FacilityAdmin, "/tee-sheet/promotion"),
    params,
    useGlobalLoader,
  );
}

export async function DeleteTeeTimePromotion(params: IDeleteTeeTimePromotion, useGlobalLoader: boolean) {
  return await APIDelete(APIUrl(AdminType.FacilityAdmin, "/tee-sheet/promotion"), params, useGlobalLoader);
}
